var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#1E2B45",
    fillOpacity: 0.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 26.7915V15.6215L25.8802 20.5015C26.2702 20.8915 26.9102 20.8915 27.3002 20.5015C27.6902 20.1115 27.6902 19.4815 27.3002 19.0915L20.7102 12.5015C20.3202 12.1115 19.6902 12.1115 19.3002 12.5015L12.7002 19.0815C12.3102 19.4715 12.3102 20.1015 12.7002 20.4915C13.0902 20.8815 13.7202 20.8815 14.1102 20.4915L19.0002 15.6215V26.7915C19.0002 27.3415 19.4502 27.7915 20.0002 27.7915C20.5502 27.7915 21.0002 27.3415 21.0002 26.7915Z",
    fill: "#F9FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendTransaction);
export default __webpack_public_path__ + "static/media/sendTransaction.81fad8435b44411c9060a5217b3fd9ab.svg";
export { ForwardRef as ReactComponent };